module.exports = __webpack_public_path__ + "static/media/VestasSans-Standard.1c294594.eot";